module.exports = __webpack_public_path__ + "media/images/cereale-desktop-8735386b7a25563a8c8fa7d750cc5a75.jpg";